(function () {
  'use strict';

  var drawerReady = false;
  var productReady = false;
  var pendingDrawer = null;
  var pendingProduct = null;

  function shouldBlockDrawerClick(target) {
    if (!target || !target.closest) return null;
    return target.closest('[data-drawer-options]');
  }

  function shouldBlockProductClick(target) {
    if (!target || !target.closest) return null;
    var card = target.closest('.t4s-product-1, .t4s-product-one, .t4s-product-11');
    if (!card) return null;
    var link = target.closest('[data-pr-href]');
    if (!link || !card.contains(link)) return null;
    if (target.closest('.t4s-pr-quickview, [data-action-quickview], .t4s-pr-wishlist, [data-action-wishlist], .t4s-pr-compare, [data-action-compare], .t4s-product-btns2 a, .t4s-product-btns2 button, .t4s-product-colors, .t4s-pr-color__item, .t4s-product-sizes, .t4s-product-size, .t4s-p1-atc-bottom-panel, .t4s-p1-atc-trigger')) {
      return null;
    }
    var isDesktop = window.matchMedia ? window.matchMedia('(min-width: 768px)').matches : true;
    if (isDesktop) {
      return card.querySelector('[data-action-quickview]') ? link : null;
    }
    return card.querySelector('.t4s-p1-atc-bottom-panel') ? link : null;
  }

  function replayDrawer() {
    if (!drawerReady || !pendingDrawer) return;
    var el = pendingDrawer;
    pendingDrawer = null;
    window.setTimeout(function () {
      el.click();
    }, 0);
  }

  function replayProduct() {
    if (!productReady || !pendingProduct) return;
    var el = pendingProduct;
    pendingProduct = null;
    window.setTimeout(function () {
      el.click();
    }, 0);
  }

  document.addEventListener('click', function (e) {
    if (!drawerReady) {
      var drawerEl = shouldBlockDrawerClick(e.target);
      if (drawerEl) {
        e.preventDefault();
        e.stopPropagation();
        pendingDrawer = drawerEl;
        return;
      }
    }

    if (!productReady) {
      var productLink = shouldBlockProductClick(e.target);
      if (productLink) {
        e.preventDefault();
        e.stopPropagation();
        pendingProduct = productLink;
      }
    }
  }, true);

  function waitDrawerReady() {
    if (window.jQuery_T4NT && window.T4SThemeSP && T4SThemeSP.Drawer) {
      drawerReady = true;
      replayDrawer();
      return;
    }
    window.setTimeout(waitDrawerReady, 30);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', waitDrawerReady);
  } else {
    waitDrawerReady();
  }

  window.__t4sEarlyGuard = {
    setProductReady: function () {
      productReady = true;
      replayProduct();
    }
  };
})();
